import { processMapAndJsonValue } from "../json-input/json-input.utils";

const getFormValues = (values: Record<string, any>, jsonOrMapFields: Record<string, any> = {}): Record<string, any> => {
    let stringifiedValues = {};
    Object.keys(values).forEach(key => {
        if (key === "" || key === "undefined" || key === "null") {
            return;
        }
        if (Array.isArray(values[key]) && jsonOrMapFields[key.toLowerCase()] !== undefined) {
            let processedValue = processMapAndJsonValue(jsonOrMapFields, key, values[key]);
            return (stringifiedValues[key] = processedValue);
        }
        if (values[key] !== null && typeof values[key] === "object" && values[key]["value"] !== undefined) {
            return (stringifiedValues[key] = values[key]?.value);
        }
        stringifiedValues[key] = values[key];
    });
    return stringifiedValues;
};

export { getFormValues };
